import { render, staticRenderFns } from "./EleFormTransfer.vue?vue&type=template&id=e9995d18&"
import script from "./EleFormTransfer.vue?vue&type=script&lang=js&"
export * from "./EleFormTransfer.vue?vue&type=script&lang=js&"
import style0 from "./EleFormTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports